/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{findScriptDependencies as o}from"./treeAnalysis.js";import{parse as r}from"./lib/arcade-parser.js";import{ParsingError as e,ParsingErrorCodes as i}from"./lib/types.js";function n(n,d=[]){const l=r(n);if(null===l.body||void 0===l.body)throw new e({index:0,line:0,column:0,data:null,description:"",code:i.InvalidExpression});return l.loadedModules={},o(l,d),l}export{n as parseScript};
